import MiniMap from './MiniMap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'

const mapStateToProps = state => {
  return {
    selectedRegionId: state.REGIONS.selecedRegionId,
    selectedRegionCountryMeta: state.REGIONS.selectedRegionCountryMeta
  }
}

export default withRouter(connect(mapStateToProps)(MiniMap));


// WEBPACK FOOTER //
// ./src/modules/Content/MiniMap/index.js